"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZEmailBlocklistRequest = void 0;
const zod_1 = require("zod");
exports.ZEmailBlocklistRequest = zod_1.z.object({
    email: zod_1.z.string().email(),
});
//# sourceMappingURL=models.js.map